module.exports = __webpack_public_path__ + "img/logo.46050b1c.png";